import React from 'react';
import { Carousel as OriginalCarousel, SlidesIndicator } from '@fiverr-private/carousel';

const Carousel = ({ withSlidesIndicator, children, ...props }) => (
    <OriginalCarousel {...props}>
        {withSlidesIndicator && <SlidesIndicator />}
        {children}
    </OriginalCarousel>
);
export default Carousel;
